import React, { useState, useEffect } from 'react'
import TreatmentPlanForm from '../treatment-plan-form/TreatmentPlanForm'
import APIResponse from '../../../../templates/components/APIResponse';
import moment from 'moment'
import TreatmentPlanService from '../../../../../services/api/treatment-plan.service';

const TreatmentPlanAdd = (props) => {
    const [formData, setFormData] = useState({})
    const [messages, setMessages] = useState({})
    const [isLoader, setIsLoader] = useState(false)
    const [apiResponse,setApiResponse] = useState()

    const onSuccess = (message) => {
        if (props.refresh) {
            props.refresh()
        }
        if (props.onClose) {
            props.onClose()
        }
        if (props.exitHandler) {
            props.exitHandler()
        }
    }
    const submitHandler = (data,details) => {
        //console.log(JSON.stringify(data))
            let reqObj = { ...data }
            reqObj.treatmentPlanDetail = details.map(x => {
                x.quantity = x.quantity ? +x.quantity : null
                x.statusId = x.statusId ? +x.statusId : null
                delete x.index
                return x
            })
            setIsLoader(true)
            TreatmentPlanService.addTreatmentPlan(reqObj)
                .then(response => {
                    setApiResponse(response)
                    clearForm()
                    setIsLoader(false)
                })
                .catch(error => {
                    setApiResponse(error)
                    setIsLoader(false)
                })
    }

    const clearForm = () => {
        setFormData({ })
    }
    return (
        <div>
            <TreatmentPlanForm  submitHandler={submitHandler} onClose={()=>props.onClose()} initialData={formData} patient={props.patient} isLoader={isLoader} messages={messages} />
            <APIResponse apiResponse={apiResponse} onSuccess={onSuccess} toastOnSuccess={true}/>
        </div>
    )
}

export default TreatmentPlanAdd